"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const qr_scanner_1 = __importDefault(require("qr-scanner"));
const react_intl_1 = require("react-intl");
const SlideDrawer_1 = __importDefault(require("../SlideDrawer"));
const addressValidator_1 = require("../../helpers/addressValidator");
const store_1 = require("../../context/store");
const actions_1 = require("../../context/actions");
const styled_1 = require("./styled");
const ExclamationTriangle_1 = __importDefault(require("../../../IconsNavigation/ExclamationTriangle"));
const QrScan = ({ open, setOpen }) => {
    const { selectedCrypto } = (0, store_1.useTrackedState)();
    const videoRef = (0, react_1.useRef)(null);
    const dispatch = (0, store_1.useDispatch)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const [invalidAddress, setInvalidAddress] = (0, react_1.useState)(false);
    const [userFile, setUserFile] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)(false);
    const [errorMsg, setErrorMsg] = (0, react_1.useState)();
    const [scannerError, setScannerError] = (0, react_1.useState)(false);
    const [scannerErrorMsg, setScannerErrorMsg] = (0, react_1.useState)();
    const handleClose = (0, react_1.useCallback)(() => {
        setOpen(false);
        setUserFile(undefined);
        setInvalidAddress(false);
        setError(false);
        setErrorMsg(undefined);
        setScannerError(false);
        setScannerErrorMsg(undefined);
    }, [setOpen]);
    const handleScanData = (0, react_1.useCallback)((res) => {
        setInvalidAddress(false);
        const cleanedAddress = (0, addressValidator_1.cleanAddress)(res.data);
        const validAddress = (0, addressValidator_1.validateAddress)(cleanedAddress);
        if (validAddress) {
            dispatch({
                type: actions_1.CONTEXT_ACTIONS.SET_ADDRESS,
                payload: cleanedAddress,
            });
            handleClose();
        }
        else {
            setInvalidAddress(true);
        }
    }, [dispatch, handleClose]);
    (0, react_1.useEffect)(() => {
        if (!videoRef.current || !open)
            return undefined;
        const qrScanner = new qr_scanner_1.default(videoRef.current, handleScanData, {
            onDecodeError: (err) => {
                if (err.toString() === "No QR code found") {
                    console.log(err.toString());
                    return;
                }
                console.log("Decode error", err);
                setScannerError(true);
                setScannerErrorMsg(err.toString());
            },
            // calculateScanRegion?: (video: HTMLVideoElement) => QrScanner.ScanRegion;
            // preferredCamera?: QrScanner.FacingMode | QrScanner.DeviceId;
            highlightScanRegion: true,
            highlightCodeOutline: true,
            // overlay?: HTMLDivElement;
            /** just a temporary flag until we switch entirely to the new api */
            returnDetailedScanResult: true,
        });
        qrScanner
            .start()
            .then()
            .catch((e) => {
            console.log("Camera error", e);
            setScannerError(true);
            setScannerErrorMsg(e);
        });
        return () => {
            qrScanner.destroy();
        };
    }, [error, handleScanData, open, videoRef]);
    const handleFileName = (0, react_1.useCallback)((file) => {
        setUserFile(undefined);
        if (file.length > 25) {
            const truncatedFileName = `${file.slice(0, 10)}...${file.slice(-12, file.length)}`;
            setUserFile(truncatedFileName);
        }
        else {
            setUserFile(file);
        }
    }, []);
    const handleFileChange = (0, react_1.useCallback)((e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
            if (!file)
                return;
            handleFileName(file.name);
            const scanResult = yield qr_scanner_1.default.scanImage(file, {
                returnDetailedScanResult: true,
            });
            handleScanData(scanResult);
        }
        catch (err) {
            // console.log("file read error", err);
            setInvalidAddress(false);
            setError(true);
            setErrorMsg(err);
        }
    }), [handleFileName, handleScanData]);
    return (react_1.default.createElement(SlideDrawer_1.default, { show: open, closeFn: handleClose, title: formatMessage({ id: "buy.qrScanner-title" }) },
        react_1.default.createElement("div", { style: { padding: "0 32px" } },
            scannerError ? (react_1.default.createElement(styled_1.CameraError, null,
                react_1.default.createElement(ExclamationTriangle_1.default, { size: 30 }),
                react_1.default.createElement("p", null, scannerErrorMsg))) : (react_1.default.createElement(styled_1.StyledVideo, { ref: videoRef })),
            react_1.default.createElement(styled_1.StyledOr, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.qrScanner-or" })),
            react_1.default.createElement(styled_1.StyledLabel, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.qrScanner-file" }),
                react_1.default.createElement("input", { type: "file", onChange: handleFileChange, accept: "image/*" })),
            error && userFile && !invalidAddress && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styled_1.StyledImageSrc, null, userFile),
                react_1.default.createElement(styled_1.StyledInvalid, null, errorMsg))),
            invalidAddress && (react_1.default.createElement(react_1.default.Fragment, null,
                userFile && react_1.default.createElement(styled_1.StyledImageSrc, null, userFile),
                react_1.default.createElement(styled_1.StyledInvalid, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.qrScanner-invalid-address", values: { code: selectedCrypto.code } })))))));
};
exports.default = QrScan;
//# sourceMappingURL=QrScanner.js.map